// src/authProvider.js

// API проксируется nginx: /api/ -> 127.0.0.1:8003 (бэкенд isbot/assistant)
export const apiUrl = "https://ai.intimshop.ru/api"
//export const apiUrl = "https://ai.intimshop.ru:8000"
//export const apiUrl = "http://localhost:8000";

export const authProvider = {

  /*
  login: async ({ username, password }) => {
    try {
      const response = await fetch(apiUrl+"/auth/token", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({ username, password }),
      });

      if (!response.ok) {
        throw new Error("Login failed");
      }

      const data = await response.json();

      // Сохраняем токен в localStorage
      localStorage.setItem("token", data.access_token);
      document.cookie = `users_access_token=${data.access_token}; path=/; Secure; HttpOnly; SameSite=Strict`;


      return Promise.resolve();
    } catch (error) {
      return Promise.reject(new Error("Invalid credentials"));
    }
  },
  */

  login: async ({ username, password }) => {
    try {
      // Создаём объект FormData или вручную кодируем строку
      const params = new URLSearchParams();
      params.append('username', username);
      params.append('password', password);
      // Необязательные поля (можно опустить, если не нужны)
      // params.append('grant_type', 'password');

      const response = await fetch(apiUrl + "/auth/token", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          // "accept": "application/json" — не обязателен, но можно добавить
        },
        // credentials: "include" — НЕ нужен для Bearer-токенов (только если используете cookies)
        body: params.toString(),
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Login error response:", errorText);
        throw new Error("Login failed");
      }

      const data = await response.json();

      // Сохраняем токен
      localStorage.setItem("token", data.access_token);
      // ❗ HttpOnly cookie нельзя установить через JS — это делает сервер!
      // document.cookie = ... ← ЭТО НЕ РАБОТАЕТ для HttpOnly!

      return Promise.resolve();
    } catch (error) {
      console.error("Login failed:", error);
      return Promise.reject(new Error("Invalid credentials"));
    }
  },

  logout: () => {
    localStorage.removeItem("token");
    document.cookie = `users_access_token=; path=/; Secure; HttpOnly; SameSite=Strict`;

    return Promise.resolve();
  },

  checkError: (error) => {
    const status = error.status;

    if (status === 401 || status === 403) {
      localStorage.removeItem("token");
      return Promise.reject();
    }

    return Promise.resolve();
  },

   checkAuth: () =>
      localStorage.getItem("token") ? Promise.resolve() : Promise.reject(),

  getPermissions: () => Promise.resolve(),
};